/**
 * FirebaseError
 * Firebase에서 발생하는 에러 메세지를 핸들링하는 모델
 */
const isFirebaseError = (error: any) => {
    return error && error.code && error.name === "FirebaseError";
}

export default isFirebaseError;